<template lang="pug">
  .answers-task
    UserInfo(
      v-if="task.user"
      :user="task.user"
      :tariffs="tariffs"
    )
    OptionsList.answers-card__options(
      v-if="$permissionsUpdate"
      :optionsFields="optionsFields"
    )

    TaskItem(
      v-for="(taskItem, idx) in task.questionArray" :key="taskItem.question.id"
      :propTaskItem="taskItem"
      :userInfo="task.user"
      :scripts="task.scripts"
      :ddl="task.taskBlock.ddl"
      :ddlDateString="ddlDate"
      :answerCreatedAt="answerCreatedAt"
      :systemName="task.taskBlock.systemName"
      :isOpen="isOpen"
      :touch="touch"
      @hasErrors="hasErrors($event, {idx})"
      @updateTaskItem="updateTaskItem($event, {idx})"
    )
      template(v-slot:edit v-if="$permissionsUpdate && isOpen")
        .answers-task__buttons
          Button.answers-task-send.-xs-(
            @click="sendFeedTaskCall"
          )
            | Отправить
          Button.answers-task-cancel.-xs-(
            @click="closeBlockEdit"
          )
            | Отклонить

</template>
<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import moment from 'moment-timezone';
moment.locale('ru');

import TaskItem from './TaskItem';
import UserInfo from './UserInfo';

export default {
  components: {
    UserInfo,
    TaskItem
  },
  props: {
    propTask: {},
    taskInfo: {},
    tariffs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkedQuestions: [],
      task: {
        questionArray: [],
        user: {
          email: ''
        },
        taskBlock: {}
      },
      touch: false,
      errors: [],
      isOpen: false,
      lessonIdFromList: ''
    };
  },
  computed: {
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.taskAnswerCheckAdmin,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    ...mapState('answersValidatingFeed', {
      storeLessonId: s => s.data.lessonId,
      feedTaskList: s => s.data.feedTaskList
    }),
    optionsFields() {
      const arr = [];
      if (!this.isOpen) {
        arr.push({
          text: 'Редактирование',
          func: this.openBlockEdit,
          icon: 'edit'
        });
      }

      if (this.isOpen) {
        arr.push({
          text: 'Закрыть',
          func: this.closeBlockEdit,
          icon: 'close',
          red: true
        });
      }

      return arr;
    },
    answerCreatedAt() {
      if (this.task.questionArray[0]) {
        const date = moment.tz(
          this.task.questionArray[0].answer.createdAt,
          'Europe/Moscow'
        );
        return date.format('DD.MM.YYYY в HH:mm:ss');
      }
      return undefined;
    },
    ddlDate() {
      if (this.task.questionArray[0] && this.task.taskBlock.ddl) {
        const date = moment.tz(this.task.taskBlock.ddl, 'Europe/Moscow');
        return date.format('DD.MM.YYYY в HH:mm:ss');
      }
      return undefined;
    },
    isDDL() {
      if (!this.ddlDate) {
        return;
      }

      const date = moment(this.ddlDate);
      return date.isValid();
    },
    afterDdl() {
      const ddl = moment
        .tz(this.task.taskBlock.ddl, 'Europe/Moscow')
        .format('DD.MM.YYYY HH:mm:ss');
      const current = moment()
        .tz('Europe/Moscow')
        .format('DD.MM.YYYY HH:mm:ss');

      return current > ddl;
    }
  },
  watch: {
    propTask() {
      this.task = _.cloneDeep(this.propTask);
    }
  },
  mounted() {
    this.task = _.cloneDeep(this.propTask);
  },
  methods: {
    ...mapActions('answersValidatingFeed', ['sendFeedTask']),
    sendFeedTaskCall() {
      this.touch = true;

      // проверяем валидацию
      if (this.errors.length > 0) {
        return;
      }

      const check = {
        questionArray: [...this.task.questionArray]
      };
      this.sendFeedTask({ check, taskInfo: this.taskInfo });
      this.isOpen = false;
    },
    updateTaskItem(taskItem, { idx }) {
      this.task.questionArray[idx] = {
        ...taskItem,
        lessonId: this.getLessonId()
      };
    },
    getLessonId() {
      if (this.storeLessonId) {
        return this.storeLessonId;
      } else if (this.lessonIdFromList) {
        return this.lessonIdFromList;
      } else if (this.feedTaskList.length) {
        this.feedTaskList.forEach(el => {
          if (this.lessonIdFromList) {
            return;
          }
          if (el.courses && el.courses.length) {
            el.courses.forEach(course => {
              if (course.tasks) {
                const obj = course.tasks.find(
                  t => t.id === this.task.taskBlock.id
                );
                if (obj) {
                  this.lessonIdFromList = obj.lessonId;
                }
              }
            });
          }
        });
        return this.lessonIdFromList;
      }
    },
    hasErrors(value, { idx }) {
      const errorIdx = this.errors.findIndex(e => e === idx);

      if (value) {
        if (errorIdx === -1) {
          this.errors.push(idx);
        }
      } else {
        if (errorIdx !== -1) {
          this.errors.splice(idx, 1);
        }
      }
    },
    openBlockEdit() {
      this.isOpen = true;
    },
    closeBlockEdit() {
      this.isOpen = false;
    }
  }
};
</script>
